import React, { useEffect, useMemo, useState } from 'react';
import { Box, CircularProgress, Paper, TextField, Typography } from '@mui/material';
import { format } from 'date-fns';
import useFetch from '../../../../hooks/useFetch.js';
import { getV2PlayerDetails, postV2Player } from '../../../../../api/index.js';
import { useNavigate, useParams } from 'react-router-dom';
import { getUserProvider } from '../../../../../actions/auth.js';
import { useNotifications } from '../../../../notifications/NotificationManager.js';
import { getRootUrl } from '../../../../../api/infoEnv.js';
import Button from '../../../../components/Button.js';
import PlayerDTO from '../../../../DTO/PlayerDTO.js';
import SelectDisciplines from '../../../../components/SelectDisciplines.js';
import SelectTeams from '../../../../components/SelectTeams.js';
import SelectNationality from '../../../../components/SelectNationality.js';

const defaultPlayerData = new PlayerDTO({ 
    lastname : "", 
    firstname : "", 
    nationality : "", 
    department : "",
    additionalInfo: "",
    birthdate : (() => { let date = new Date(); date.setHours(0,0,0,0); return date.toISOString()})(), 
    disciplines : [],
    teams : [],
    provider : getUserProvider() 
})

const FormPlayer = ({ player = defaultPlayerData}) => {

    const navigate = useNavigate()

    const { addNotification } = useNotifications();

    const [formPlayer, setFormPlayer] = useState(player)

    const { data, isLoading, error, fetchData } = useFetch(postV2Player, [[formPlayer]]);

    useEffect(() => {

        if(!data)
            return

        // Envoyer une notif au service de notification
        addNotification({
            title: formPlayer._id ? 'Edition d\'un athlète' : 'Création d\'un athlète',
            type: 'success',
            description: 'Votre athlète a été ' + (formPlayer._id ? 'modifié' : 'créée') + ' avec succès !',
            //link: getRootUrl() +'/live/'+data._id+'/calendar'
        });

        // Rediriger vers la page des joueurs
        navigate("/multisport/actors/players");

    }, [data])

    useEffect(() => {

        if(!error)
            return

        // Envoyer une notif au service de notification
        addNotification({
            title: formPlayer._id ? 'Edition d\'un athlète' : 'Création d\'un athlète',
            type: 'error',
            description: error.status + ' - ' + error.message,
            //link: getRootUrl() +'/live/'+data._id+'/calendar'
        });

    }, [error])

    const handleChange = (e) => {

        const {name, value} = e.target

        setFormPlayer(s => ({...s, [name] : value}))
    }

    const isValidForm = useMemo(() => {
        return formPlayer.lastname && formPlayer.nationality && 
        formPlayer.disciplines && formPlayer.disciplines.length > 0 && !formPlayer.disciplines.some(discipline => !discipline._id) && 
        formPlayer.provider

    }, [formPlayer])

    const handleSubmit = async () => {
        // Controles du form
        if(!isValidForm)
            return

        fetchData()
    }


    if(isLoading)
        return <CircularProgress/>

    return <Paper sx={{ p: 3, maxWidth: 600, mx: "auto" }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ mb: 4 }}>
                    {formPlayer._id ? "Edition" : "Création"} d'un athlète
                </Typography>
                
                <Box sx={{ width: '100%', maxWidth: 400, mb: 2 }}>
                    <TextField
                    fullWidth
                    name="lastname"
                    label="Nom"
                    onChange={handleChange}
                    value={formPlayer.lastname}
                    sx={{ mb: 2 }}
                    />
                    <TextField
                    fullWidth
                    name="firstname"
                    label="Prénom"
                    onChange={handleChange}
                    value={formPlayer.firstname}
                    sx={{ mb: 2 }}
                    />
                    <Box sx={{ mb: 2 }}>
                    <SelectNationality
                        name="nationality"
                        handleChange={handleChange}
                        selectedNationality={formPlayer.nationality}
                    />
                    </Box>
                    <TextField
                    fullWidth
                    label="Date de naissance"
                    name="birthdate"
                    type="date"
                    value={formPlayer.birthdate && format(new Date(formPlayer.birthdate), "yyyy-MM-dd")}
                    InputLabelProps={{ shrink: true }}
                    onChange={handleChange}
                    sx={{ mb: 2 }}
                    />
                    <Box sx={{ mb: 2 }}>
                    <SelectDisciplines
                        selectedDisciplines={formPlayer.disciplines}
                        handleChange={handleChange}
                        name="disciplines"
                    />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                    <SelectTeams
                        selectedTeams={formPlayer.teams}
                        handleChange={handleChange}
                        name="teams"
                        disciplines={formPlayer.disciplines}
                    />
                    </Box>
                    <TextField
                        fullWidth
                        name="department"
                        label="Département"
                        onChange={handleChange}
                        value={formPlayer.department}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        fullWidth
                        name="additionalInfo"
                        label="Informations complémentaires"
                        onChange={handleChange}
                        value={formPlayer.additionalInfo}
                        sx={{ mb: 2 }}
                    />
                </Box>
                
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={!isValidForm}
                >
                    Valider mon formulaire
                </Button>
                </Box>
            </Paper>

}

export default FormPlayer